import React from 'react';
import { AppBar, Badge, Box, IconButton, Toolbar } from "@mui/material";
import { Menu, ShoppingBagOutlined } from "@mui/icons-material";
import { Link as RouterLink, useNavigate } from "react-router-dom";
import FormSelect from "../FormSelect";
import NavLink from "./NavLink";
import { useNavAppBarStyles } from "./NavAppBar.styles";
import { useLanguage } from "../../../hooks/LanguageProvider";
import { useI18n } from "../../../i8n/useI18n";
import { useCart } from "../../../hooks/useCart";

interface NavAppBarProps {
    toggle: () => void;
}

const NavAppBar = (props: NavAppBarProps) => {
    const { language, availableLanguages, handleLanguageChange } = useLanguage();
    const { t } = useI18n();
    const navigate = useNavigate();
    const { classes } = useNavAppBarStyles();
    const { cart } = useCart();
    const itemCount = cart?.totalQuantity ?? 0;

    return (
        <AppBar component="nav" position="sticky" className={classes.appBar}>
            <Toolbar className={classes.toolbar}>
                {/* Brand */}
                <Box className={classes.brand} onClick={() => navigate("/")}>
                    <Box component="span" className={classes.brandName}>{t("brand.name")}</Box>
                </Box>

                {/* Desktop nav */}
                <Box className={classes.desktopActions}>
                    <Box className={classes.desktopNav}>
                        <NavLink name={t("nav.shop")} href={t("links.shop")} />
                        <NavLink name={t("nav.journal")} href={t("links.blog")} />
                        <NavLink name={t("nav.contact")} href={t("links.contact")} />
                    </Box>
                    <Box className={classes.actions}>
                        <FormSelect
                            label="Language"
                            value={language}
                            items={availableLanguages}
                            onChange={handleLanguageChange}
                            sx={{ width: 90 }}
                        />
                        <IconButton
                            component={RouterLink}
                            to={t("links.cart")}
                            aria-label={t("nav.cart")}
                            className={classes.cartButton}
                        >
                            <Badge badgeContent={itemCount} color="primary">
                                <ShoppingBagOutlined />
                            </Badge>
                        </IconButton>
                    </Box>
                </Box>

                {/* Mobile actions */}
                <Box className={classes.mobileActions}>
                    <IconButton
                        component={RouterLink}
                        to={t("links.cart")}
                        aria-label={t("nav.cart")}
                        className={classes.cartButton}
                    >
                        <Badge badgeContent={itemCount} color="primary">
                            <ShoppingBagOutlined />
                        </Badge>
                    </IconButton>
                    <IconButton
                        aria-label={t("nav.menu")}
                        edge="start"
                        onClick={props.toggle}
                        className={classes.menuIconButton}
                    >
                        <Menu />
                    </IconButton>
                </Box>
            </Toolbar>
        </AppBar>
    );
};

export default NavAppBar;
